var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('moveHeadLogo',{on:{"navigation":_vm.navigation}}),_c('moveNavigation',{attrs:{"headTitle":_vm.headTitle,"headImg":_vm.headImg}}),_c('moveMeauDialog',{attrs:{"meauValue":_vm.navigationvalue},on:{"meauFn":_vm.menu}}),_c('el-row',{staticClass:"list"},[_c('noticesdetailsdata')],1),_c('moveBottomNavigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }